import React from "react";
import { I18N } from "../I18N";

export interface I18NTextProps {
    text?: string;
    children: string;
}
const I18NText = ({ text = null, children = null }) => {
    return (
        <>{I18N.Translate(children ?? text)}</>
    )
}

export default I18NText;